module.exports = __webpack_public_path__ + "img/word.067c4504.png";